import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { once } from '@ember/runloop';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import didUpdate from 'webapp/modifiers/did-update';
import FormInputComponent from 'webapp/components/form/input';

import type Block from 'webapp/models-custom/block';
import type BlockSetup from 'webapp/models-custom/block-setup';
import type VisualizationTable from 'webapp/models-custom/visualization/table';

interface Args {
	blockM: Block;
}

export default class BlockSettingsLabelHeaderComponent extends Component<Args> {
	@tracked labelHeaderToEdit = '';

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.updateLabelHeaderToEdit(false);
	}

	get block(): Block {
		return this.args.blockM;
	}

	get blockSetup(): BlockSetup {
		return this.block.blockSetup;
	}

	get visualization() {
		return this.blockSetup.visualization as VisualizationTable;
	}

	checkAndUpdateLabelHeaderOnBlock(): void {
		const labelHeader = this.labelHeaderToEdit.trim();
		if (labelHeader === this.visualization.defaultLabelHeader) {
			this.block.labelHeader = '';
		} else {
			this.block.labelHeader = labelHeader;
		}
		this.blockSetup.saveBlock();
	}

	updateLabelHeaderToEdit(doBlockCheck: boolean) {
		this.labelHeaderToEdit = this.visualization.labelHeader || '';
		if (doBlockCheck) {
			this.checkAndUpdateLabelHeaderOnBlock();
		}
	}

	@action
	updateLabelHeaderToEditNext() {
		once(this, this.updateLabelHeaderToEdit, true);
	}

	@action
	endEdit(): void {
		// "revert on empty"
		const labelHeader = this.labelHeaderToEdit.trim();
		if (!labelHeader) {
			this.labelHeaderToEdit = this.visualization.defaultLabelHeader || '';
		}
		this.checkAndUpdateLabelHeaderOnBlock();
	}
	<template>
		<div
			class="row row--lr"
			{{didUpdate
				this.updateLabelHeaderToEditNext
				this.visualization.tableColumnType
				@blockM
			}}
		>
			<label>Label header</label>
			<div class="right">
				<FormInputComponent
					name="label-header"
					maxlength="50"
					@value={{this.labelHeaderToEdit}}
					@focusOut={{this.endEdit}}
					@loseFocusOnEnter={{true}}
					@theme="dark"
				/>
			</div>
		</div>
	</template>
}
